import type { LineAnchor, LineCap } from '../../core/interfaces/board-object.interface.js';

/**
 * Swap-relevant snapshot of a `LineObject` — the fields that move
 * atomically when start/end are swapped. PRD-010 §Finding 6 (DRY):
 * single source of truth for the swap transformation, used by both
 * `SwapLineCapsCommand.apply()` and `CommandSerializer`.
 */
export interface LineSwapSnapshot {
  readonly x1: number;
  readonly y1: number;
  readonly x2: number;
  readonly y2: number;
  readonly startCap: LineCap;
  readonly endCap: LineCap;
  readonly startAnchor?: LineAnchor;
  readonly endAnchor?: LineAnchor;
}

/**
 * Mirror a line-swap snapshot: swap ONLY the two end caps, so the shapes
 * (arrow / dot / square) visibly change sides. The endpoints and anchors stay
 * put — swapping them as well would move each cap back to its old screen
 * position, making the whole action a visual no-op. Involution:
 * `mirror(mirror(s)) === s`.
 */
export const mirrorLineSwap = (s: LineSwapSnapshot): LineSwapSnapshot => ({
  ...s,
  startCap: s.endCap,
  endCap: s.startCap,
});
